import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { NoveltySearchInputState } from './novelty-search-input-state';
import { NoveltySearchInputStateImpl } from './impls/novelty-search-input-state-impl';

/**
 * 查新检索输入状态服务模块
 */
export const noveltySearchInputStateModule = new ContainerModule((bind) => {
    bind(NoveltySearchInputState).to(NoveltySearchInputStateImpl);
});
